// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ProviderLookupIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ProviderLookup/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.833 12.035c0 .896.688 1.618 1.542 1.618h1.743c.743 0 1.347-.632 1.347-1.41 0-.847-.368-1.146-.916-1.34L6.75 9.93c-.549-.195-.917-.493-.917-1.34 0-.778.604-1.41 1.348-1.41h1.743c.854 0 1.541.722 1.541 1.618M8.145 6.25v8.333"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m13.333 2.578-2.083.99-2.43-.99-2.431.99L2.5 2.083v15.834l3.403-1.485 2.916 1.485 2.431-1.485 2.917 1.485V12.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.939 9.809a2.286 2.286 0 1 0 0-4.572 2.286 2.286 0 0 0 0 4.572ZM17.653 10.237l-.714-.714"
}));
export default ProviderLookupIcon;
